import { capitalize } from '../ui/utils';
export const HOURS_QUOTE_VALID_FOR = 60 * 24;
export const ASYNC_API_CACHE_KEY_PREFIX = '@dunvegan:api:cache';
export const ASYNC_SETTINGS_KEY_PREFIX = '@dunvegan:settings';
export const ASYNC_USER_CACHE_KEY_PREFIX = '@dunvegan:user:cache';
export const AUTHORIZATION_LOCAL_STORAGE_KEY = `oidc.user:${import.meta.env.VITE_KALIDASA_BASE_URI}:${import.meta.env.VITE_OPENQUOTE_CLIENT_ID}`;
// Which identity provider the app authenticates against. 'kalidasa' (the
// default when VITE_AUTH_PROVIDER is unset) keeps today's behavior
// exactly; 'portal' points the same OIDC flow at the auth portal, which
// serves the same endpoint paths but returns a signed id_token that
// oidc-client validates against the provider's JWKS.
export const AUTH_PROVIDER = import.meta.env.VITE_AUTH_PROVIDER === 'portal' ? 'portal' : 'kalidasa';

/*
TODO
combined the utils folder and constants folder into "helpers" folder.
most of the constants should be relevant to a utility function anyway.
*/

export const CoverageNames = {
  collision: 'Collision',
  hail: 'Windstorm and Hail',
  wind: 'Wind',
  falsePretense: 'False Pretense',
  comprehensive: 'Comprehensive',
  terrorism: 'Certified Acts of Terrorism',
  earthquake: 'Earthquake',
  flood: 'Flood',
};

export const CoverageShortForms = {
  comprehensive: 'Comp',
  flood: 'Flood',
  collision: 'Collision',
  earthquake: 'EQ',
  terrorism: 'Terrorism',
  hail: 'Hail',
  falsePretense: 'False Pretense',
};

export const CoverageTypes = {
  collision: 'collision',
  hail: 'hail',
  falsePretense: 'falsePretense',
  comprehensive: 'comprehensive',
  terrorism: 'terrorism',
  earthquake: 'earthquake',
  flood: 'flood',
};

export const CoverageTypeSubTypes = {
  comprehensive: {
    fire: 'fire',
    theft: 'theft',
    vandalism: 'vandalism',
  },
};

export const QuoteStatuses = {
  pending: 'pending',
  released: 'released',
  prebound: 'prebound',
  bound: 'bound',
  rejected: 'rejected',
  expired: 'expired',
};

export const UserRoles = {
  admin: 'admin',
  broker: 'dunvegan:broker',
  underwriter: 'dunvegan:underwriter',
  internal: 'dunvegan:internal',
  ops: 'dunvegan:internal', // <- TODO: verify ops user role...is it admin?
  policyAnalyst: 'dunvegan:policy_analyst',
};

// The two dealer captive products a CSV application can be filed under.
export const ProductIds = {
  NDI: 'bce823f1-ff62-481d-9713-7523e2cd8047', // Dealer Captive Open Lot
  HDI: '5a784be1-2b17-41ac-92a8-625d24ceb55f', // Large Dealer Captive Open Lot
};

export const ProductNames = {
  ahs: 'Auto Hail Safe',
  orca: 'Dealer Captive Open Lot',
};

export const ProductTypes = {
  auto: 'Auto',
  ag: 'Agriculture',
};

export const QUOTE_REQUEST = 'request';
export const QUOTE_ADJUSTMENT = 'adjustment';

export const MessageTypes = {
  request: 'request',
  adjustment: 'adjustment',
};

export const MessageTypeName = {
  request: 'Request',
  adjustment: 'Adjustment',
};

export const MessageTypeUserRole = {
  request: 'Broker',
  adjustment: 'Underwriter',
};

export const Colors = {
  quoteStatus: {
    pending: '$brandOrange',
    released: '$sky.light',
    prebound: '$coral.main',
    bound: '$secondary',
    rejected: '$gray.600',
    expired: '$gray.500',
    Active: '#1CB24F29',
    Executed: '#1CB24F29',
    Inactive: '#B21C1C29',
    Draft: '#FFAB0029',
    Pending: '#FFE4B299',
    Superseded: '$gray.200',
    Cancelled: '#9CA3AF29',
    Reversal: '#eb0101ff',
    IVE: '#1E40AF29', // Dark blue background for IVE badge (brighter blue, same format as Active/Executed)
  },
  mceStatus: {
    retrospective: '#1CB24F29',
    locationChange: '#EAFBFD',
    legacy: '#E6F8F4',
    quarterly: '#1E40AF29',
  },
};
export const TextColors = {
  Active: '#15893D',
  Executed: '#15893D',
  Draft: '#B76E00',
  Inactive: '$coral.main',
  retrospective: '#15893D',
  locationChange: '$sky.main',
  Pending: '#FFC107',
  legacy: '$coral.main',
  quarterly: '#1E40AF',
  Reversal: '#000000',
  Cancelled: '#374151',
  IVE: '#1E40AF', // Dark blue text for IVE badge (matching background, brighter blue)
};
export const quoteStatusOptions = {};
for (const key in QuoteStatuses) {
  quoteStatusOptions[key] = {
    name: QuoteStatuses[key],
    value: QuoteStatuses[key],
    color: Colors.quoteStatus[key] ? Colors.quoteStatus[key] : '$gray.200',
    label: capitalize(QuoteStatuses[key]),
  };
}
export const BindingFormTypes = {
  siteChecklist: 'site-checklist',
  leaseAgreement: 'lease-agreement',
};

export const ClaimStatusTypes = {
  open: 'open',
  adjusting: 'adjusting',
  denied: 'denied',
  accepted: 'accepted',
};

export const claimStatusOptions = {};
for (const key in ClaimStatusTypes) {
  claimStatusOptions[key] = {
    name: ClaimStatusTypes[key],
    value: ClaimStatusTypes[key],
    label: capitalize(ClaimStatusTypes[key]),
  };
}

export const ListDisplayTypes = {
  TABLE: 'table',
  CARDS: 'card',
};

export const SORT_ASC = 'ASC';
export const SORT_DESC = 'DESC';

export const sortByOptions = {
  ASC: {
    name: SORT_ASC,
    label: 'Ascending',
  },
  DESC: {
    name: SORT_DESC,
    label: 'Descending',
  },
};

export const filterOperators = {
  equals: 'equals',
  lte: 'lte',
  lt: 'lt',
  gte: 'gte',
  gt: 'gt',
  like: 'like',
  ilike: 'ilike',
  notequals: 'notequals',
};

export const MAX_FILE_SIZE = 20 * 1024 * 1024;

export const DEFAULT_APP_SETTINGS = {
  listDisplayType: ListDisplayTypes.CARDS,
  // Which policy page a user sees while VITE_POLICY_DETAILS_V2 is on: 'new' or 'legacy' (UND-1235).
  policyView: 'new',
};
